/* eslint-disable */
<template>
  <div class="specialist-appointments">
    <SpecialistNavigation indexProps="2" />
    <div class="top-panel">
      <Header />
      <div class="header-title-section">
        <div class="header-title"><h1>Appointments</h1></div>
        <div class="d-flex justify-content-between align-center w-100">
          <div class="header-sub-title">The following appointments are upcoming in your schedule.</div>
          <div class="d-flex align-center fs-12">
            <div style="background: green; width: 14px; height: 14px; border-radius: 50%"></div>
            <span class="ml-1">Availability Booking</span>
            <div class="ml-1" style="background: yellow; width: 14px; height: 14px; border-radius: 50%"></div>
            <span class="ml-1">Non-availability Booking</span>
            <el-checkbox disabled class="default-checkbox ml-1 mt-2" type="checkbox" readonly checked ></el-checkbox>
            <span class="ml-1">Paperwork is available to download for this booking</span>
          </div>
        </div>
      </div>
    </div>
    <div class="panel d-flex calc-width">
      <SpecialistBookingMenu indexProps="2" />
      <div style="width: 220px; flex-shrink: 0;" />
      <div class="content" style="flex: 1; left: 0">
        <!-- <ThreeWeekCalendar :passedBookingsProps="bookings" /> -->
        <div class="d-flex align-center justify-center" style="font-size: 20px">
          <div :class="leftArrow ? '' : 'disabled'" class="is-icon move-icon" @click="previousMonth"><img src="@/assets/images/previous_icon.svg" /></div>
          <div>{{ getMonth(calendarDate) }}</div>
          <div :class="rightArrow ? '' : 'disabled'" class="is-icon move-icon" @click="nextMonth"><img src="@/assets/images/next_icon.svg" /></div>
        </div>
        <div class="calendar-month">
          <v-row class="fill-height">
            <v-col>
              <v-sheet height="1200">
                <v-calendar
                  id="calendar"
                  ref="calendar"
                  color="primary"
                  type="month"
                  v-model="calendarDate"
                  :short-months="false"
                  :short-weekdays="false"
                  :events="bookings.map((x) => x.calendarEvent)"
                  @click:date="openDate"
                  @click:more="openMoreBookings"
                >
                  <template v-slot:event="{ event }">
                    <div class="fill-height calendar-event">
                      <div class="indicator-circle" :style="'background-color:' + event.dotColor" style="margin-top: 2px"></div>
                      <p class="long-text" data-placement="top" data-toggle="tooltip" data-html="true" :title="event.name" :time="event.start">
                        <router-link  :to="{ name: 'specialist-booking-detail', query: {id:event.id} }">
                          <div class="d-flex flex-wrap align-items-start">
                            <span>{{ decodeURIComponent(event.name)}}</span>
                            <span class="ml-1">{{ formatDateTime(event.start, 'hh:mm A', 'YYYY-MM-DD hh:mm') }}</span>
                            <el-checkbox v-if="event.PaperworkProcessed" class="default-checkbox ml-1" type="checkbox" readonly checked ></el-checkbox>
                          </div>
                        </router-link>
                      </p>
                    </div>
                  </template>
                </v-calendar>
              </v-sheet>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
    <Chat />
    <el-dialog
      :title="selectedDayTitle"
      :visible.sync="dayBookingsDialogVisible"
      width="520px"
      class="day-bookings-dialog"
    >
      <div v-if="selectedDayBookings.length === 0" class="text-muted">No bookings for this day.</div>
      <div v-else class="day-bookings-list">
        <div
          v-for="event in selectedDayBookings"
          :key="event.id"
          class="day-booking-item calendar-event"
        >
          <div class="indicator-circle" :style="'background-color:' + event.dotColor" style="margin-top: 2px"></div>
          <router-link :to="{ name: 'specialist-booking-detail', query: { id: event.id } }">
            <div class="d-flex flex-wrap align-items-start">
              <span>{{ decodeURIComponent(event.name) }}</span>
              <span class="ml-1">{{ formatDateTime(event.start, 'hh:mm A', 'YYYY-MM-DD hh:mm') }}</span>
              <el-checkbox v-if="event.PaperworkProcessed" class="default-checkbox ml-1" type="checkbox" readonly checked></el-checkbox>
            </div>
          </router-link>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import utilities from '@/assets/js/utilities'
  import SpecialistNavigation from '@/components/SpecialistNavigation'
  import SpecialistBookingMenu from '@/components/SpecialistBookingMenu'
  import Header from '@/components/Header'
  import Chat from '@/components/Chat'

  const APPOINTMENTS_MONTH_STORAGE_KEY = 'specialistAppointmentsCurrentMonth'

  export default {
    name: 'SpecialistAppointments',
    components: {
      SpecialistNavigation,
      SpecialistBookingMenu,
      Header,
      Chat,
    },
    data() {
      return {
        leftArrow: true,
        rightArrow: true,
        dateToGo: '',
        dateToBack: '',
        nextTwoWeek: '',
        today: window.moment().format('YYYY-MM-DD'),
        bookings: [],
        calendarDate: window.moment().format('YYYY-MM-DD'),
        dayBookingsDialogVisible: false,
        selectedDayBookings: [],
        selectedDayDate: '',
      }
    },
    computed: {
      user() {
        return this.$store.getters['user/getUser'];
      },
      start() {
        return window.moment()
          .startOf('week')
          .format('YYYY-MM-DD')
      },
      end() {
        return window.moment()
          .endOf('week')
          .add(3, 'w')
          .format('YYYY-MM-DD')
      },
      selectedDayTitle() {
        if (!this.selectedDayDate) {
          return 'Bookings'
        }
        return utilities.formatDate(this.selectedDayDate, 'dddd, MMMM D, YYYY', 'YYYY-MM-DD')
      },
    },
    methods: {
      getPersistedMonth() {
        const savedMonth = sessionStorage.getItem(APPOINTMENTS_MONTH_STORAGE_KEY)
        if (savedMonth && window.moment(savedMonth, 'YYYY-MM-DD', true).isValid()) {
          return window.moment(savedMonth, 'YYYY-MM-DD').startOf('month').format('YYYY-MM-DD')
        }
        return window.moment().startOf('month').format('YYYY-MM-DD')
      },
      persistCurrentMonth() {
        sessionStorage.setItem(
          APPOINTMENTS_MONTH_STORAGE_KEY,
          window.moment(this.calendarDate, 'YYYY-MM-DD').startOf('month').format('YYYY-MM-DD')
        )
      },
      updateMonthArrowState() {
        this.leftArrow = this.calendarDate !== this.dateToBack
        this.rightArrow = this.calendarDate !== this.dateToGo
      },
      formatDateTime(date, format, currentFormat = "YYYY-MM-DD") {
        if (date != '') {
          if (format == 'MMM, YYYY hh:mm A' && this.booking.bookingStatus == 16) {
            format = 'MMM, YYYY'
            return utilities.formatDate(date, format, currentFormat)
          } else {
            return utilities.formatDate(date, format, currentFormat)
          }
        }
        return ''
      },
      getMonth(date) {
        return utilities.formatDate(date, 'MMMM YYYY', "YYYY-MM-DD")
      },
      async previousMonth() {
        this.$store.dispatch('loading/setLoadComponent', true)

        this.calendarDate = window.moment(this.calendarDate, "YYYY-MM-DD")
          .subtract(1, 'month').startOf('month')
          .format('YYYY-MM-DD')
        this.updateMonthArrowState()
        this.persistCurrentMonth()

        if (this.user.specialistId != undefined && this.user.specialistId != '') {
          const {bookings} = await utilities.getSpecialistUpcomingBookings({
            pageNum: 1,
            pageSize: 999,
            BookingStartDate: this.calendarDate,
            BookingEndDate: window.moment(this.calendarDate, "YYYY-MM-DD").endOf('month').format('YYYY-MM-DD'),
          }, true)
          this.bookings = bookings
        }
        this.$store.dispatch('loading/setLoadComponent', false)
      },
      async nextMonth() {
        await this.$store.dispatch('loading/setLoadComponent', true)

        this.calendarDate = window.moment(this.calendarDate, "YYYY-MM-DD")
          .add(1, 'month').startOf('month')
          .format('YYYY-MM-DD')
        this.updateMonthArrowState()
        this.persistCurrentMonth()
        if (this.user.specialistId != undefined && this.user.specialistId != '') {
          const {bookings} = await utilities.getSpecialistUpcomingBookings({
            BookingEndDate: window.moment(this.calendarDate, "YYYY-MM-DD").endOf('month').format('YYYY-MM-DD'),
            BookingStartDate: this.calendarDate,
            pageNum: 1,
            pageSize: 999,
          }, true)
          this.bookings = bookings
        }
        await this.$store.dispatch('loading/setLoadComponent', false)
      },
      async loadBookings() {
        this.dateToGo =  window.moment().add(3, 'M').format('YYYY-MM-DD')
        this.dateToBack =  window.moment().subtract(12, 'M').format('YYYY-MM-DD')
        this.nextTwoWeek =  window.moment().add(2, 'W').format('YYYY-MM-DD')
        this.calendarDate = this.getPersistedMonth()
        this.updateMonthArrowState()
        await this.$store.dispatch('loading/setLoadComponent', true)
        const {bookings} = await utilities.getSpecialistUpcomingBookings({
          BookingStartDate: this.calendarDate,
          BookingEndDate: window.moment(this.calendarDate, "YYYY-MM-DD").endOf('month').format('YYYY-MM-DD'),
          pageNum: 1,
          pageSize: 999,
        }, true)
        // var shownBookingStatuses = ["3","4","8"]
        this.bookings = bookings
        console.log(this.bookings)
        this.persistCurrentMonth()
        await this.$store.dispatch('loading/setLoadComponent', false)
      },
      checkStatus(e) {
        var date = window.moment(e.start, "YYYY-MM-DD HH:mm").format('YYYY-MM-DD')
        if (date <= this.nextTwoWeek) {
          return true
        }
        return false
      },
      openDate(e) {
        this.persistCurrentMonth()
        this.$router.push({ name: "specialist-bookings-day", query: {date:e.date} }).catch((err) => {})
      },
      openMoreBookings(e) {
        const date = e.date
        this.selectedDayDate = date
        this.selectedDayBookings = this.bookings
          .filter((booking) => {
            const eventDate = window.moment(booking.calendarEvent.start, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD')
            return eventDate === date
          })
          .map((booking) => booking.calendarEvent)
          .sort((a, b) => window.moment(a.start, 'YYYY-MM-DD HH:mm').valueOf() - window.moment(b.start, 'YYYY-MM-DD HH:mm').valueOf())
        this.dayBookingsDialogVisible = true
      },
    },
    async beforeMount() {
      await this.loadBookings()
    },
    mounted() {
      window.scrollTo(0, 0)
    },
  }
</script>

<style scoped>
.day-bookings-list {
  max-height: 420px;
  overflow-y: auto;
}

.day-booking-item {
  display: flex;
  padding: 8px;
  margin-bottom: 8px;
  background: #f8f8f8;
  border-radius: 4px;
}

.day-booking-item:last-child {
  margin-bottom: 0;
}
</style>
